<template>
    <div class="tile">
        <div class="tile-title">
            <div>
                <h2 :class="{'tile-title-link': $auth.$pages['customer-details'].isAllowed}" v-fs-block>
                    <router-link :to="{name: 'customer-details', params: {id: entry.id}}">{{entry.displayName}}</router-link>
                </h2>
                <p class="text-muted no-stack">Customer since {{getTimeSince(this.entry.createdTime)}}</p>
            </div>
            <div class="avatar no-flex">
                <div class="avatar-image" v-fs-block>
                    <div class="avatar-initials avatar-initials-blue">
                        <span>{{entry.initials}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="tile-content">
            <ul class="list list-group">
                <li class="list-item" v-if="canReadInvoice">
                    <v-icon icon="orders" class="no-flex inline-s"/>
                    <p class="no-flex" v-fs-block>{{invoicesCount}} Invoices</p>
                </li>
                <li class="list-item" v-if="canReadSubscriptions">
                    <v-icon icon="orders" class="no-flex inline-s"/>
                    <p class="no-flex" v-fs-block>{{subscriptionsCount}} Orders</p>
                </li>
                <li class="list-item" v-if="canReadTransactions">
                    <v-icon icon="transactions" class="no-flex inline-s"/>
                    <p class="no-flex" v-fs-block>{{transactionsCount}} Transactions</p>
                </li>
            </ul>
        </div>
        <!-- additional information panels -->
        <slot name="additional-information"/>
    </div>
</template>

<script>
    import {vIcon} from '@/components/form';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import vContact from '@/components/v-contact';
    import OrderModel from '@/common/models/order-model';
    import TransactionModel from '@/common/models/transaction-model';

    export default {
        mixins: [LoadStateMixin],
        name: 'compact-customer-summary',
        components: {
            vIcon,
            vContact,
        },
        props: {
            entry: {
                type: Object,
            },
            expand: {
                type: Object,
            },
        },
        data() {
            return {
                transactionsCount: null,
                invoicesCount: null,
                subscriptionsCount: null,
            };
        },
        computed: {
            canReadInvoice() {
                return this.$auth.invoices.read.isAllowed && (this.expand instanceof TransactionModel);
            },
            canReadTransactions() {
                return this.$auth.transactions.read.isAllowed;
            },
            canReadSubscriptions() {
                return this.$auth.subscriptions.isAllowed && this.expand instanceof OrderModel;
            },
        },
        methods: {
            getTimeSince(time) {
                return this.$tz().readUTC(time).fromNow();
            },

            async fetchData() {
                const filter = `customerId:${this.entry.id}`;
                const promises = [];
                if (this.canReadTransactions) {
                    promises.push(this.getTransactions({filter}));
                }
                if (this.canReadInvoice) {
                    promises.push(this.getInvoices({filter}));
                }
                if (this.canReadSubscriptions) {
                    promises.push(this.getSubscriptions({filter}));
                }
                await Promise.all(promises);
            },

            async getTransactions(filter) {
                const {total} = await this.$api(({transactions}) => transactions.getAll(filter));
                this.transactionsCount = total;
            },

            async getInvoices(filter) {
                const {total} = await this.$api(({invoices}) => invoices.getAll(filter));
                this.invoicesCount = total;
            },

            async getSubscriptions(filter) {
                const {total} = await this.$api(({subscriptions}) => subscriptions.getAll(filter));
                this.subscriptionsCount = total;
            },
        },
    };
</script>
